export const FAQ_LIST = 'FAQ_LIST'